import { render, staticRenderFns } from "./ScrollList.vue?vue&type=template&id=07e0e4d3"
import script from "./ScrollList.vue?vue&type=script&lang=js"
export * from "./ScrollList.vue?vue&type=script&lang=js"
import style0 from "./ScrollList.vue?vue&type=style&index=0&id=07e0e4d3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports